import _get from 'lodash/get';

import { getVideoPlayerDataPath } from './constants';
import { getFunctionArgValue } from '../utils/functions';
import { getCollectionPropValue } from '../utils/props';

export function getVideoPropValue(propName, component, defaultValue) {
  return _get(component, getVideoPlayerDataPath(propName), defaultValue);
}

export function getPropFunctionArgValue(
  props,
  { propName, functionArgName, defaultValue = undefined },
) {
  const contentFunc = getCollectionPropValue(props, propName);

  if (!contentFunc) {
    return defaultValue;
  }
  return getFunctionArgValue(contentFunc, functionArgName) || defaultValue;
}
